import { useState, useEffect } from "react";

// Returns the total *scrollable* height of the document.
function getDocumentHeight() {
  const { body, documentElement: html } = document;
  return Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );
}

/**
 * Returns the full document height (in px).
 * Automatically recalculates on scroll and resize.
 */
export function useDocumentHeight() {
  const [documentHeight, setDocumentHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeight = () => {
      setDocumentHeight(getDocumentHeight());
    };

    updateHeight();

    window.addEventListener("scroll", updateHeight);
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("scroll", updateHeight);
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return documentHeight;
}
